import {
    AMOUNT_ACTION,
    BACK_SCREEN,
    CARD_NUMBER_ACTION,
    COMMENT_ACTION,
    IN_CURRENCY_ACTION,
    IN_CURRENCY_SHOW_ACTION,
    INIT,
    MIN_MAX_HALF_ACTION,
    NEXT_SCREEN,
    OUT_CURRENCY_ACTION,
    OUT_CURRENCY_SHOW_ACTION,
    OUT_DESTINATION_ACTION,
    OUT_DESTINATION_SHOW_ACTION,
    OUT_DESTINATION_TIME_ACTION,
    PROVIDER_ACTION,
    SWAP_CURRENCY_ACTION,
    ORDER_CREATED_ACTION,
    NOT_ACTIVE_OUT_CURRENCY_ACTION,
    NOT_ACTIVE_IN_CURRENCY_ACTION,
    NEW_OUT_DESTINATION_ACTION,
    VALIDATION_OUT_DESTINATION_ACTION,
    SEARCH_MODAL_IN_ACTION,
    SEARCH_MODAL_OUT_ACTION,
    CURRENCY_ARRAY_ACTION,
    MODAL_ERROR_ACTION,
    LOADER_ACTION,
    FAIL_PROVIDERS,
    IN_CURRENCY_COIN,
    OUT_CURRENCY_COIN,
    CLOSE_MODAL_ACTION,
    RATE_PROVIDER_ACTION,
    WALLET_NAME_ACTION,
    LIMITS_ARRAY_ACTION,
    BACK_FIRST_SCREEN_ACTION,
    ADVANCED_CLOSE_ACTION,
    DESTINATION_TAG_ACTION,
    CREATED_ORDER_ERROR,
    EXPIRATED_RATE,
    ORDER_ACTION,
    MODAL_SERVER,
    MIN_MAX_ACTION,
    COUNTED_FEES,
    CHECKED_ALMOST_ALL,
    LOADING_ACTION,
    POST_MESSAGE_ERROR,
    BALANCE_HODL_MSG
} from '../type'

const INITIAL_STATE = {
    sign: {},

    screen: 1,
    allExchangeWays: [],
    walletData: null,
    cashbackToken: null,
    // locale: null,

    inCurrency: null,
    outCurrency: null,
    // payway: null,
    // exchangeWayType: null,

    swapCurrencyTouchName: null,
    inAmount: null,
    amountValid: false,
    amountTimerId: null,
    amountHaveValid: false,
    minMaxLimits: {},
    outAmount: null,
    side: null,

    outDestination: null,
    inDestination: null,
    newOutDestination: false,
    cardNumber: null,
    provider: null,
    providersArray: [],
    failProviders: false,
    rateProvider: null,
    outDestinationTag: null,
    walletName: null,
    email: null,
    comment: null,

    inCurrencyArray: [],
    inCurrencyNotActiveArray: [],
    outCurrencyArray: [],
    outCurrencyNotActiveArray: [],

    searchValueInCurrency: null,
    searchValueOutCurrency: null,

    orderCreated: false,
    order: null,
    createdOrderError: false,
    equivalentTime: null,
    expiratedRate: false,

    destinationValid: false,
    destinationError: false,
    destinationTag: null,

    modalError: false,

    loader: false,
    loading: false,

    minMaxHalf: null,
    limitsTimerId: null,
    // emailMessage: false,
    // feeData: null,
    //
    // cardData: null,
    // cardValid: false,
    // isFetching: false,
    // link: null,

    inCurrencyShow: false,
    outCurrencyShow: false,
    outDestinationShow: false,

    version: null,

    useAllFunds: false,
    modalServer: false,

    limitLabel: false,

    loadAmount: false,

    checkedAlmostAll: null,
    originalData: {},

    maxLimit: false,

    textError: null,

    versionNumber: null,
    postMessageError: false,
    balanceHodlMsg: null

}

const mobileExchangerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INIT:
            return {
                ...state,
                allExchangeWays: action.allExchangeWays,
                walletData: action.walletData,
                cashbackToken: action.cashbackToken,
                screen: action.screen,
                sign: action.sign,
                inCurrency: action.inCurrency,
                outCurrency: action.outCurrency,
                minMaxLimits: action.minMaxLimits,
                outDestination: action.outDestination,
                walletName: action.walletName,
                rateProvider: action.rateProvider,
                version: action.version,
                inDestination: action.inDestination,
                versionNumber: action.versionNumber
            }
        case IN_CURRENCY_ACTION:
            return {
                ...state,
                inCurrency: action.inCurrency,
                inCurrencyShow: false,
                inAmount: null,
                outAmount: null,
                swapCurrencyTouchName: action.inCurrency,
                searchValueInCurrency: null,
                minMaxHalf: null,
                minMaxLimits: action.minMaxLimits,
                limitLabel: false,
                inDestination: action.inDestination,
                loading: false,
                amountTimerId: null
            }
        case OUT_CURRENCY_ACTION:
            return {
                ...state,
                outCurrency: action.outCurrency,
                outDestination: action.outDestination,
                walletName: action.walletName,
                outCurrencyShow: false,
                inAmount: null,
                outAmount: null,
                searchValueOutCurrency: null,
                minMaxLimits: action.minMaxLimits,
                minMaxHalf: null,
                limitLabel: false,
                loading: false,
                amountTimerId: null
            }
        case AMOUNT_ACTION:
            return {
                ...state,
                inAmount: action.amount,
                outAmount: action.equivalent,
                amountTimerId: action.timerId,
                providersArray: action.providersArray,
                amountValid: action.amountValid,
                amountHaveValid: action.amountHaveValid,
                loading: action.loading,
                side: action.side,
                equivalentTime: action.equivalentTime,
            }
        case NEXT_SCREEN:
            return {
                ...state,
                screen: action.screen
            }
        case BACK_SCREEN:
            return {
                ...state,
                screen: state.screen * 1 - 1,
                destinationValid: false,
                newOutDestination: false
            }
        case BACK_FIRST_SCREEN_ACTION:
            return {
                ...state,
                provider: null,
                screen: 1
            }
        case OUT_DESTINATION_ACTION:
            return {
                ...state,
                outDestination: action.outDestination,
                walletName: action.walletName,
                outDestinationShow: false,
                newOutDestination: false,
                destinationValid: false,
            }
        case CARD_NUMBER_ACTION:
            return {
                ...state,
                cardNumber: action.cardNumber
            }
        case COMMENT_ACTION:
            return {
                ...state,
                comment: action.comment
            }
        case PROVIDER_ACTION:
            return {
                ...state,
                provider: action.provider
            }
        case MIN_MAX_HALF_ACTION:
            return {
                ...state,
                minMaxHalf: action.minMaxHalf,
                minMaxLimits: action.minMaxLimits,
                loading: true,
                failProviders: false,
            }
        case IN_CURRENCY_SHOW_ACTION:
            return {
                ...state,
                inCurrencyShow: !state.inCurrencyShow,
                outCurrencyShow: false
            }
        case OUT_CURRENCY_SHOW_ACTION:
            return {
                ...state,
                outCurrencyShow: !state.outCurrencyShow,
                inCurrencyShow: false
            }
        case OUT_DESTINATION_SHOW_ACTION:
            return {
                ...state,
                outDestinationShow: !state.outDestinationShow,
                newOutDestination: false,
                destinationValid: false,
            }
        case OUT_DESTINATION_TIME_ACTION:
            return {
                ...state,
                outDestination: action.outDestination,
                walletName: null,
            }
        case ORDER_CREATED_ACTION:
            return {
                ...state,
                orderCreated: !state.orderCreated,
            }
        case SWAP_CURRENCY_ACTION:
            return {
                ...state,
                inCurrency: state.outCurrency,
                outCurrency: state.inCurrency,
                inAmount: null,
                outAmount: null,
                amountValid: false,
                outDestination: action.outDestination,
                inDestination: action.inDestination,
                walletName: action.walletName,
                minMaxHalf: null,
                failProviders: false,
                minMaxLimits: action.minMaxLimits,
                newOutDestination: false,
                destinationValid: false,
                limitLabel: false,
                provider: null,
                providersArray: [],
                useAllFunds: false,
                loadAmount: false
            }
        case NOT_ACTIVE_IN_CURRENCY_ACTION:
            return {
                ...state,
                inCurrency: action.inCurrency,
                inCurrencyShow: false,
                outCurrency: null,
                inAmount: null,
                outAmount: null,
                minMaxHalf: null,
                inDestination: action.inDestination,
                loading: false,
                amountTimerId: null
            }
        case NOT_ACTIVE_OUT_CURRENCY_ACTION:
            return {
                ...state,
                inCurrency: null,
                outCurrencyShow: false,
                outCurrency: action.outCurrency,
                outDestination: action.outDestination,
                walletName: action.walletName,
                inAmount: null,
                outAmount: null,
                minMaxHalf: null,
                loading: false,
                amountTimerId: null
            }
        case NEW_OUT_DESTINATION_ACTION:
            return {
                ...state,
                newOutDestination: !state.newOutDestination,
                outDestinationShow: false,
                outDestination: null,
            }
        case VALIDATION_OUT_DESTINATION_ACTION:
            return {
                ...state,
                destinationValid: action.destinationValid,
                destinationError: action.destinationError
            }
        case SEARCH_MODAL_IN_ACTION:
            return {
                ...state,
                searchValueInCurrency: action.searchValue
            }
        case SEARCH_MODAL_OUT_ACTION:
            return {
                ...state,
                searchValueOutCurrency: action.searchValue
            }
        case CURRENCY_ARRAY_ACTION:
            return {
                ...state,
                currencyArray: action.currencyArray,
                currencyNotActiveArray: action.currencyNotActiveArray,
            }
        case MODAL_ERROR_ACTION:
            return {
                ...state,
                modalError: action.modalError,
                failProviders: action.failProviders,
                inCurrencyShow: false,
                outCurrencyShow: false,
                outDestinationShow: false,
                textError: action.textError
            }
        case LOADER_ACTION:
            return {
                ...state,
                loader: action.loader,
            }
        case FAIL_PROVIDERS:
            return {
                ...state,
                failProviders: action.failProviders,
                rateProvider: state.rateProvider === null ? action.rateProvider : state.rateProvider,
                limitLabel: false
            }
        case IN_CURRENCY_COIN:
            return {
                ...state,
                inCurrencyArray: action.inCurrencyActive,
                inCurrencyNotActiveArray: action.inCurrencyNotActive
            }
        case OUT_CURRENCY_COIN:
            return {
                ...state,
                outCurrencyArray: action.outCurrencyActive,
                outCurrencyNotActiveArray: action.outCurrencyNotActive
            }
        case CLOSE_MODAL_ACTION:
            return {
                ...state,
                inCurrencyShow: false,
                outCurrencyShow: false,
                outDestinationShow: false
            }
        case RATE_PROVIDER_ACTION:
            return {
                ...state,
                rateProvider: action.rateProvider,
                minMaxLimits: action.minMaxLimits,
                minMaxHalf: null,
                limitLabel: false
            }
        case WALLET_NAME_ACTION:
            return {
                ...state,
                screen: 4,
                outDestination: action.outDestination,
                walletName: action.walletName,
                outDestinationShow: false
            }
        case LIMITS_ARRAY_ACTION:
            return {
                ...state,
                minMaxLimits: action.minMaxLimits,
                limitsTimerId: action.limitsTimerId,
                limitLabel: false
            }
        case ADVANCED_CLOSE_ACTION:
            return {
                ...state,
                screen: 1,
                newOutDestination: action.newOutDestination
            }
        case DESTINATION_TAG_ACTION:
            return {
                ...state,
                destinationTag: action.destinationTag
            }
        case CREATED_ORDER_ERROR:
            return {
                ...state,
                createdOrderError: action.createdOrderError
            }
        case EXPIRATED_RATE:
            return {
                ...state,
                expiratedRate: action.expiratedRate
            }
        case ORDER_ACTION:
            return {
                ...state,
                order: action.order
            }
        case MODAL_SERVER:
            return {
                ...state,
                modalServer: action.modalServer,
                textError: action.textError
            }
        case MIN_MAX_ACTION:
            return {
                ...state,
                minMaxLimits: action.minMaxLimits,
                limitLabel: action.limitLabel
            }
        case COUNTED_FEES:
            return {
                ...state,
                useAllFunds: action.useAllFunds,
                loadAmount: action.loadAmount
            }
        case CHECKED_ALMOST_ALL:
            return {
                ...state,
                checkedAlmostAll: action.checkedAlmostAll,
                originalData: action.originalData
            }
        case LOADING_ACTION:
            return {
                ...state,
                loading: action.loading
            }
        case POST_MESSAGE_ERROR:
            return {
                ...state,
                postMessageError: action.postMessageError
            }
        case BALANCE_HODL_MSG:
            return {
                ...state,
                balanceHodlMsg: action.balanceHodlMsg
            }

        default:
            return { ...state }
    }
}

export default mobileExchangerReducer